import React, { useEffect, useState } from 'react';
import { Checkbox, Collapse, CollapseProps, Table } from 'antd';
import { NameOf } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';
import { FilterValue } from 'antd/lib/table/interface';
import AssetListItemDTO from 'src/models/generated/AssetListItemDTO';

export interface AssestsTableProps {
  data?: AssetListItemDTO[];
  loading?: boolean;
}

const AssestsTable: React.FC<AssestsTableProps> = (props) => {
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null>>({});
  const [openKeys, setOpenKeys] = useState<Parameters<Required<CollapseProps>['onChange']>[0]>(['1']);
  const tableData = props.data ?? [];

  useEffect(() => {
    if (props.loading) {
      setFilteredInfo({});
    }
  }, [props.loading]);

  const tableColumns: ColumnProps<AssetListItemDTO>[] = [
    TableColumnBuilder.Create<AssetListItemDTO>('assetName', 'Asset Name')
      // .Width(400)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .DefaultSortOrder('ascend')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<AssetListItemDTO>('pos', 'POS')
      .Width(100)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<AssetListItemDTO>('code', 'Code')
      .Width(100)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<AssetListItemDTO>('activationCode', 'Activation Code')
      .Width(300)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Typography', { copyable: true, ellipsis: true })
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<AssetListItemDTO>('reseller', 'Reseller')
      .Width(300)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<AssetListItemDTO>('quantity', 'Quantity')
      .Width(100)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<AssetListItemDTO>('disabled', 'Disabled')
      .Width(100)
      .Align('center')
      .AddRenderer('Custom', (val) => <Checkbox disabled checked={val}></Checkbox>)
      .FilteredValue(filteredInfo)
      .Build(),
  ];

  return <div className='assets-table table-section'>
    <Collapse ghost collapsible='header' activeKey={openKeys} onChange={setOpenKeys}>
      <Collapse.Panel key={1} header={<h3 className='table-title'>Assets</h3>}>
        <Table
          rowKey={NameOf<AssetListItemDTO>('id')}
          className='condensed-table striped-table borderless-table'
          rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
          loading={props.loading}
          pagination={false}
          columns={tableColumns}
          dataSource={tableData}
          onChange={(_, filters) => { setFilteredInfo(filters); }}
        />
      </Collapse.Panel>
    </Collapse>
  </div>;
};

export default AssestsTable;
